import { atom, useAtom } from "jotai"
import { useEffect } from "react"

const userAtom = atom<User | null>(null)

export default function useUser() {
    const [user, setUser] = useAtom(userAtom)

    useEffect(() => {
        // avoid reassigning user if it's already set
        if (!user) {
            // as a user fetch
            setUser({
                ...window.CURRENT_USER,
            })
        }
    }, [])

    const updateUser = (fields: Partial<User>) => {
        if (user) {
            setUser({ ...user, ...fields })
        }
    }

    const isLoading = !user

    return {
        user,
        isLoading,
        updateUser,
    }
}
